module.exports = __webpack_public_path__ + "img/dashboard.e1597685.svg";